import apiClient from './client';
import type {
  AIAnalysisResult,
  AIAnalysisRequest,
  AIAnalysisHistory,
  AnalysisType,
} from '@/types/ai';
import type { PaginatedResponse } from '@/types/api';

export interface AIAnalysisHistoryParams {
  company_id: number;
  page?: number;
  per_page?: number;
  analysis_type?: AnalysisType;
}

export const aiApi = {
  // AI分析実行
  analyze: async (params: AIAnalysisRequest): Promise<AIAnalysisResult> => {
    const response = await apiClient.post<AIAnalysisResult>('/api/ai/analysis', params);
    return response.data;
  },

  // 分析履歴取得
  getHistory: async (params: AIAnalysisHistoryParams): Promise<PaginatedResponse<AIAnalysisHistory>> => {
    const response = await apiClient.get<PaginatedResponse<AIAnalysisHistory>>('/api/ai/analysis/history', { params });
    return response.data;
  },

  // 分析結果詳細取得
  getAnalysis: async (id: number): Promise<AIAnalysisResult> => {
    const response = await apiClient.get<AIAnalysisResult>(`/api/ai/analysis/${id}`);
    return response.data;
  },

  // キャッシュクリア
  clearCache: async (companyId: number): Promise<void> => {
    await apiClient.delete(`/api/ai/cache/${companyId}`);
  },
};
